"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class OrderService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'orders';
        /**
         * Obtener una orden de compra y los detalles (sku version)
         * @param id (Number) 'Id de la orden de compra'
         */
        this.getOrderById = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.statusText);
        };
        /**
         * Cancela la asignación del producto adquirido por el usuario.
         * @param orderId (Number) 'Id de la orden de compra'
         * @param productId (Number) 'Id del producto'
         */
        this.cancelProductAssigment = async (orderId, productId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${orderId}/products/assignment`;
            const response = await axios_1.default.put(URL, JSON.stringify({ product_id: productId, is_assigned: false }), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.statusText);
        };
        /**
         * Aceptar la asignación del producto adquirido por el usuario.
         * @param orderId (Number) 'Id de la orden de compra'
         * @param productId (Number) 'Id del producto'
         */
        this.acceptProductAssigment = async (orderId, productId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${orderId}/products/assignment`;
            const response = await axios_1.default.put(URL, JSON.stringify({ product_id: productId, is_assigned: true }), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.OrderService = OrderService;
